import {
    IIcon,
} from './types';

import calendarImage from './media/calendar.svg';
import eyeIcon from './media/eye.svg';
import eyeOffIcon from './media/eye-off.svg';
import searchImage from './media/search.svg';

export function mapIconSrc(icon: IIcon): string {
    switch (icon) {
        case 'search': {
            return searchImage;
        }
        case 'eye': {
            return eyeIcon;
        }
        case 'eye-off': {
            return eyeOffIcon;
        }
        case 'calendar': {
            return calendarImage;
        }
    }
}
